module.exports = __webpack_public_path__ + "img/img4.154e9156.png";